<template>
  <div class="app-wrapper">
    <Head />
    <Banner />
    <HeaderNav :data="headerNavigation" />
    <div class="app-main">
      <!-- <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" /> -->
      <router-view />
    </div>
    <Blogroll />
    <foot />
  </div>
</template>

<script>
import { Head, Banner, Blogroll, Foot } from './components';
import HeaderNav from '@/components/HeaderNav';
import { getNavigation } from '@/api/common';

export default {
  name: 'Layout',
  components: {
    Head,
    Banner,
    HeaderNav,
    Blogroll,
    Foot
  },
  data() {
    return {
      columnId: '',
      sideBardata: [],
      headerNavigation: []
    };
  },
  mounted() {
    this.getHeaderNav();
  },
  methods: {
    key() {
      return this.route.path;
    },
    handleSelect(key, keyPath) {
      //   this.columnId = key;
      //   this.page = 1;
      if (key === '999') {
        this.$router.push('/home');
      } else {
        this.$store.commit('SET_PlAT_FROM_Array', keyPath);
        this.$router.push('/subPage');
      }
      //   this.getNewList();
    },
    // 处理成树结构。
    formatData(data, breadcrumbList = []) {
      data.forEach(item => {
        const currentBreadcrumbList = [...breadcrumbList, item.name];

        item.breadcrumbList = currentBreadcrumbList;

        if (
          item.childList &&
          Array.isArray(item.childList) &&
          item.childList.length
        ) {
          this.formatData(item.childList, item.breadcrumbList);
        }
      });
    },
    getHeaderNav() {
      getNavigation().then(res => {
        res.data.unshift({ id: 999, name: '首页', operator: '向帅' });
        this.headerNavigation = res.data;
      })
    }
  }
};
</script>

<style scoped>
.app-main {
  width: 1200px;
  margin: 0 auto;
}
</style>
